/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import axios, { AxiosRequestConfig } from 'axios';
import { API_URL } from '../constants';
import type { AxiosReturn } from '../types/return.types';
import { getAPIToken } from '../utils';

function getAxiosConfig(): AxiosRequestConfig {
  return {
    baseURL: API_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getAPIToken()}`,
    },
  };
}

export default class ProductService {
  static async getProducts(): Promise<AxiosReturn> {
    try {
      const response = await axios.get('/product', getAxiosConfig());
      return { error: false, message: 'Success', data: response.data };
    } catch (e: any) {
      const message = e?.response?.data?.message ?? e?.message ?? 'Request failed';
      return { error: true, message, data: null };
    }
  }

  static async getProduct(code: string): Promise<AxiosReturn> {
    try {
      const response = await axios.get(`/product/${code}`, getAxiosConfig());
      return { error: false, message: 'Success', data: response.data };
    } catch (e: any) {
      const message = e?.response?.data?.message ?? e?.message ?? 'Request failed';
      return { error: true, message, data: null };
    }
  }
}
